import * as service from "./service";
import { setCookies, clearCookies, getCookie,updateCookie,getReferrer} from '../../helpers/utility'
import { history } from "../../store";
import { store } from 'react-notifications-component';

function successToaster(msg){
  store.addNotification({
    title: "Success",
    message:msg,
    type: "success",
    insert: "top",
    container: "top-right",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    dismiss: {
      duration: 2000,
    }
  });
}

export default {
    state: {
      apiError:false,
      userData:getCookie() || {},
      backTositeUrl:getReferrer()
    },
    reducers: {
        onRequest(state) {
            return {
              ...state,
              loading: true,
            };
          },
          onError(state,data) {
            let err = data && data.message ? data.message :"Some error occured"
            store.addNotification({
              title: "Error",
              message:err,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 2000,
              }
            });
            return {
              ...state,
              loading: false,
              apiError:err
            };
          },
          onSentOtpSuccess(state,data){
            return {
              ...state,
              loading: false,
              apiError:null,
            };
          },
          onVerifyOtpSuccess(state,data,loginType){
            data.loginType = loginType
            setCookies(data)
            return {
              ...state,
              loading: false,
              apiError:null,
              userData:data,
            };
          },
          onGetMeSuccess(state,data){
            if(data && data.user){
              updateCookie({userData:data.user})
            }
            return {
              ...state,
              loading: false,
              apiError:null,
            };
          },
          async onLogout(state, data) {
            await clearCookies()
            if(data){
              window.location.href = data
            }else{
              history.push("/login?lt=1")
              successToaster("You have logged out successfully!")
            }
            
            return {
              loading: false
            }
          },
          onSetReffer(state,data){
            return {
              ...state,
              loading: false,
              backTositeUrl:data ? data.url : ""
            };
          }
    },
  effects: {
    async sentOtp(payload,rootState) {
      this.onRequest()
      try {
        let res = await service.sentOtp(payload)
        this.onSentOtpSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async skipVerification({ user, token, loginType }) {
      this.onRequest()
      this.onVerifyOtpSuccess({ user, token }, loginType)
    },
    async verifyOtp(payload,rootState) {
      this.onRequest()
      try {
        let res = await service.verifyOtp(payload)
        this.onVerifyOtpSuccess(res, payload.type)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async verifyOtpAutoLogin(payload,rootState) {
      this.onRequest()
      try {
        let res = await service.verifyOtpAutoLogin(payload)
        this.onVerifyOtpSuccess(res, payload.type)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getMe(payload,rootState) {
      this.onRequest()
      try {
        let res = await service.getMe(payload)
        this.onGetMeSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async logout(payload, rootState) {
      this.onLogout(payload)
    },
    async setReffer(payload, rootState) {
      this.onSetReffer(payload)
    },
  }
}